import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'align-left', 'AlignLeft', [["path",{"d":"M4 6l16 0"}],["path",{"d":"M4 12l10 0"}],["path",{"d":"M4 18l14 0"}]]);